const questions = [
  {
    id: 1,
    question: "What is the capital of France?",
    choices: ["Paris", "London", "Berlin", "Rome"],
    correctAnswer: 0,
  },
  {
    id: 2,
    question: "Who wrote 'To Kill a Mockingbird'?",
    choices: ["Harper Lee", "Mark Twain", "Ernest Hemingway", "J.K. Rowling"],
    correctAnswer: 0,
  },
  {
    id: 3,
    question: "Which planet is known as the Red Planet?",
    choices: ["Venus", "Jupiter", "Mars", "Saturn"],
    correctAnswer: 2,
  },
  {
    id: 4,
    question: "What is the chemical symbol for water?",
    choices: ["H2O", "CO2", "NaCl", "O2"],
    correctAnswer: 0,
  },
];

export default questions;



// WEBPACK FOOTER //
// ./src/components/questions.js